import { SMEX_LEARN_MORE_VIDEO, SMEX_CAROUSEL_LUMIO, SMEX_CAROUSEL_LESSONS_IN_IQ, SMEX_LEARN_MORE_VIDEO_GERMAN, SMEX_LEARN_MORE_VIDEO_SWEDISH } from './static-urls'

export const ENGLISH_US = [
  {
    path: '/static/marketing-content/SMEX_2_MARKETING.png',
    link: SMEX_LEARN_MORE_VIDEO,
    target: '_blank',
    id: 'learnMore',
    description: 'Discover SMART Exchange'
  },
  {
    path: '/static/marketing-content/SMEX_lumio.gif',
    link: SMEX_CAROUSEL_LUMIO,
    target: '_blank',
    id: 'lumio',
    description: 'Discover Lumio'
  },
  {
    path: '/static/marketing-content/SMEX_iq.png',
    link: SMEX_CAROUSEL_LESSONS_IN_IQ,
    target: '_blank',
    id: 'iq',
    description: 'Lessons in iQ'
  }
]

export const GERMAN = [
  {
    path: '/static/marketing-content/SMEX_2_MARKETING.de.png',
    link: SMEX_LEARN_MORE_VIDEO_GERMAN,
    target: '_blank',
    id: 'learnMore',
    description: 'Discover SMART Exchange'
  }
]

export const SWEDISH = [
  {
    path: '/static/marketing-content/SMEX_2_MARKETING.sv.png',
    link: SMEX_LEARN_MORE_VIDEO_SWEDISH,
    target: '_blank',
    id: 'learnMore',
    description: 'Discover SMART Exchange'
  }
]
